import { useTranslation } from "react-i18next";
import { FormContactsDataList } from "@/pages/ContactsPage/Components/FormContactsDataList";
import { useAppSelector } from "@/services/store";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import { AddressField, SocialField } from "../Fields";
import { getFullStreetNameFromContactAddress } from "../../helpers";
import { AnniversaryField } from "../Fields/AnniversaryField";

export const RightSectionList = () => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);
  if (!currentPerson) return <></>;
  return (
    <>
      <FormContactsDataList
        title={t("contactsPage.generalInfo.socialNetworks")}
        fieldArrayName={"socialNetworks"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.socialNetworkType?.name ?? "",
          value: item?.socialNetwork ?? "",
        })}
        editNode={(index) => <SocialField index={index} />}
        addableModel={{
          socialNetworkType: { name: "" },
          socialNetwork: "",
          personId: currentPerson?.id,
          id: "",
        }}
      />
      <FormContactsDataList
        valueDarkColor
        title={t("contactsPage.generalInfo.address", { count: 2 })}
        fieldArrayName={"addresses"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.addressType?.name ?? "",
          value: getFullStreetNameFromContactAddress(item) ?? "",
        })}
        editNode={(index) => <AddressField index={index} />}
        addableModel={{
          addressType: { name: "" },
          addressCity: "",
          addressCountry: "",
          addressStreet1: "",
          addressStreet2: "",
          addressPostalCode: "",
          personId: currentPerson?.id,
          id: "",
        }}
      />
      <FormContactsDataList
        title={t("contactsPage.generalInfo.anniversaries")}
        fieldArrayName={"anniversaries"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.description ?? "",
          value: item?.anniversary ?? "",
        })}
        editNode={(index) => <AnniversaryField index={index} />}
        addableModel={{
          personId: currentPerson?.id,
          anniversaryType: "",
          description: "",
          id: "",
          anniversary: "",
        }}
      />
    </>
  );
};
